// 渲染器注册表：type_key -> Vue 组件，唯一查找入口（契约见 src/contract.md）
// 用普通对象闭包而非 Map，保持可被 rollup 摇树的朴素形态
const renderers = {}

export function registerRenderer (key, comp) {
  renderers[key] = comp
}

export function getRenderer (key) {
  return Object.prototype.hasOwnProperty.call(renderers, key) ? renderers[key] : null
}

export function registeredKeys () {
  return Object.keys(renderers)
}
